import MoonIcon from './component'

export default MoonIcon
